import { clinicasApi } from '../../../api';
import { setService, clearService, setModules, clearModules } from './serviceSlice';
import { successNotification, dangerNotification } from '../ui';
import { clearNotifications } from '../ui/uiSlice';

export const startGetModules = (membresia) => {
    return async(dispatch) => {

        try {

            let resp = await clinicasApi.get(`/consultas/modulos?idMembresia=${encodeURIComponent(membresia)}`);

            if (resp.status) {

                dispatch(setModules(resp.data));
                dispatch(clearNotifications());

                return true;

            } else {

                dispatch(clearModules());
                dispatch(clearNotifications());
                dispatch(dangerNotification(resp.data.msg));

            }

            return false;

        } catch (error) {

            if (typeof error.response !== 'undefined' && typeof error.response.data !== 'undefined' && typeof error.response.data.msg !== 'undefined') {

                dispatch(clearModules());
                dispatch(clearNotifications());
                dispatch(dangerNotification(error.response.data.msg));

            } else {

                dispatch(clearModules());
                dispatch(clearNotifications());
                dispatch(dangerNotification('Error al procesar la petición, intenta nuevamente.'));

            }

            return false;

        }

    }
}

export const startService = (modulo, membresia) => {
    return async(dispatch) => {

        try {

            dispatch(successNotification('Conectando...'));

            let { data } = await clinicasApi.post(`/consultas/zoom/onDemand?idMembresia=${encodeURIComponent(membresia)}&idModulo=${encodeURIComponent(modulo)}`);
            // let { data } = await clinicasApi.post('/zoom/solicita-atencion/', {
            //     token: "axasx",
            //     membresia,
            //     modulo
            // });

            // let data = {
            //     status: 200,
            //     title: "OK",
            //     idCita: 114440759,
            //     idReunionZoom: "81834794543",
            //     passwordReunionZoom: "x25wwer",
            //     urlReunionZoom: "https://us02web.zoom.us/j/81834794543?pwd=rNita8biBPHvaJAmOShgmOKK4tfPvp.1"
            // };

            if (data.status) {

                //Datos de respuesta adicionales
                data.modulo = modulo;
                data.membresia = membresia;

                dispatch(setService({...data, modulo, origin: 'WEB' }));
                dispatch(clearNotifications());
                dispatch(successNotification('Redirigiendo'));

                return true;

            } else {

                dispatch(clearService());
                dispatch(clearNotifications());
                dispatch(dangerNotification(data.msg));

            }

            return false;

        } catch (error) {

            if (typeof error.response !== 'undefined' && typeof error.response.data !== 'undefined' && typeof error.response.data.msg !== 'undefined') {

                dispatch(clearService());
                dispatch(clearNotifications());
                dispatch(dangerNotification(error.response.data.msg));

            } else {

                dispatch(clearService());
                dispatch(clearNotifications());
                dispatch(dangerNotification('Error al procesar la petición, intenta nuevamente.'));

            }

            return false;

        }

    }
}